module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Black.b1aa788.woff";